import { request } from "../../api/api";

export const getOrderDetail = (searchParams) => {
  return request.get(`/getOrderDetail/?page=${searchParams.page + 1}&page_size=${searchParams.rowsPerPage}`);
};

export const uploadFileExcel = (formdata) => {
  return request.post(`uploadFile/`, formdata);
};

export const getUploadFile = (params) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.sl_no) queryParams.append('sl_no', params.sl_no);
  if (params.date) queryParams.append('date', params.date);
  if (params.time) queryParams.append('time', params.time);
  if (params.file_name) queryParams.append('file_name', params.file_name);
  if (params.uploded_by) queryParams.append('uploded_by', params.uploded_by);

  return request.get(`/getUploadFile/?${queryParams.toString()}`);
};

export const filterOrderDetail = (params) => {
  return request.get(
    `/filterOrderDetail/?status=${params.searchText.Status}&days_left=${params.searchText.Days_Left}&order_id=${params.searchText.Order_ID}&customer_name=${params.searchText.Customer_Name}&order_quantity=${params.searchText.Order_Qty}&paired_quantity=${params.searchText.Paired_Qty}&Packed_Qty=${params.searchText.Packed_Qty}&page=${params.page + 1}&page_size=${params.rowsPerPage}`
  );
};

export const getPrintedBoxDetails = (params,search) => {
  return request.post(`dispatch/getPrintedBoxDetails/?search=${search.Uid}&pairing__order_id__order_item_code__description=${search.ProductDescription}&pairing__order_id__order_id=${search.OrderNo}&pairing__order_id__order_item_code__ordered_item=${search.OrderID}`,params);
};

export const getBoxNo = () => {
  return request.get(`/dispatch/getBoxNo/`);
};
export const getBoxLabelPrintHistory = (params) => {
  if(params.DateofPrinting && !params.Time){
    return request.get(
      `/dispatch/getBoxPrintHistory/?search=${params.DateofPrinting}&shift__shift_name=${params.Shift}&customer_order__ordered_item=${params.OrderID}&box_no__box_no=${params.BoxNo}&box_no__no_of_prints=${params.NumberofPrints}&user__username=${params.User}&page=${params.Page + 1}&page_size=${params.Page_size}&order_number__order_id=${params.order_number}&order_number__customer_name=${params.CustomerName}`
    );
  }else{
    return request.get(
      `/dispatch/getBoxPrintHistory/?search=${params.Time}&shift__shift_name=${params.Shift}&customer_order__ordered_item=${params.OrderID}&box_no__box_no=${params.BoxNo}&box_no__no_of_prints=${params.NumberofPrints}&user__username=${params.User}&page=${params.Page + 1}&page_size=${params.Page_size}&order_number__order_id=${params.order_number}&order_number__customer_name=${params.CustomerName}`
    );

  }
  
 
};

export const removeDuplicatePairs = (params) =>{
  return request.post(`/dispatch/removeDuplicatePairs/`,params)
}
export const createBoxLabel = async (params) => {
  return await request.post(`/dispatch/createBoxLabel/`, params);
};


export const PrintAgainBoxLabel = async (params) => {
  return await request.post(`/dispatch/printAgainBoxLabel/`, params);
};

export const printAgainBoxLabel = async (params) => {
  return await request.post(`dispatch/printAgainBoxLabel/`, params);
};

export const getOrderYear = () => {
  return request.get(`getOrderYear/`);
};

export const yearsOrder = async (params) => {
  return await request.post(`yearsOrder/`, params);
};

export const getOrderbyType = (params) => {
  return request.post(`getOrderbyType/`, params);
};

export const exportProduction = (params) => {
  return request.post(`exportProduction/`, params);
};

export const getColorFilter = () => {
  return request.get(`getColorFilter/`);
};



export const getOrderbyFilter = (params) => {
  // Filter out null/undefined/empty string values
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== null && value !== undefined && value !== "")

  );

  const queryParams = Object.entries(filteredParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  const url = `/getOrderbyFilter/?${queryParams}`;

  // Send only the filtered params in body
  return request.post(url, filteredParams);
};




export const getCustomerNameList = ()=>{
  return request.get('dispatch/getCustomerNameList/')
}

export const getDispatchOrderDetail = (params)=>{
  return request.post('dispatch/getDispatchOrderDetail/',params)
}


export const getDashboardCount = (year, classId, sizeId) => {
  const yearParam = year === "Select Year" || year === "all" ? null : year;

  let url = `/getDashboardCount/`;

  const params = [];

  if (yearParam) params.push(`year=${yearParam}`);
  if (classId && classId !== "all") params.push(`class_id=${classId}`);
  if (sizeId && sizeId !== "all") params.push(`size_id=${sizeId}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return request.get(url);
};



